import {Component, Input, OnInit} from "@angular/core";
import {GlobalStoreService} from "../../../shared/_services/global-store.service";
import {ApiPathsService} from "../../../api-paths.service";
import {forkJoin} from "rxjs";
import {map} from "rxjs/operators";
import {AuthenticationService} from "../../../Login/_services/authentication.service";
import {ToastrService} from "ngx-toastr";
import {
  GetCarrelloCount,
  GetCarrelloVoci, getSpedizione, idsToBase64,
  PrezzoIvato, getEsclusivaSubtotal, GetMyPrice, GetCarrello
} from "../../../../environments/Modules/Marketplace/ProductUtility";
import {SaveToLocalStorage} from "../../../../environments/Utility/Utility";

@Component({
  selector: 'app-carrello-marketplace',
  template:`
    <div class="cov " [ngClass]="{'open': cartData?.open || cartData?.openCarrello}"  id="rcov" (click)="closeRichieste()"></div>
    <div class="cdr " [ngClass]="{'open': cartData?.open || cartData?.openCarrello}" id="rcdr">
      <div class="cdr-h">
        <div class="cdr-h-left">
          <h2>{{isCarrello() ? 'Il tuo carrello' : 'Le tue Richieste'}}</h2>
          <span class="cdr-h-badge" id="rcdrBadge">{{Count()}} articol{{Count() == 1 ? 'o' : 'i'}} {{Prodotti?.length>1 ? 'da ' + Prodotti.length + ' fornitori' : ''}}</span>
        </div>
        <button class="cx" (click)="closeRichieste()">✕</button>
      </div>
      <div class="citems" id="rcitems">
        <div class="ce" *ngIf="!Prodotti?.length && isRichieste()"><div class="ci">📋</div><p>Nessuna richiesta</p><p style="font-size:12.5px;margin-top:6px;font-weight:500;">Aggiungi prodotti con "Richiedi prodotto"</p></div>
        <div class="ce" *ngIf="!Prodotti?.length && isCarrello()"><div class="ci">🛒</div><p>Il tuo carrello è vuoto</p><p style="font-size:12.5px;margin-top:6px;font-weight:500;">Aggiungi prodotti dal catalogo per iniziare</p></div>
        <div class="c-info-banner" *ngIf="Prodotti?.length>1">
          <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
          <span>Articoli da <b>{{Prodotti?.length}} venditori diversi</b>. Ogni venditore spedisce autonomamente: potrebbero arrivare in tempi e con costi separati.</span>
        </div>
        <div class="cv-block" *ngFor="let esclusiva of Prodotti">
          <div class="cv-header">
            <div class="cv-header-left">
              <svg width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"></path></svg>
              {{esclusiva.esclusiva?.nominativo ?? "Nessun negozio definito"}}
            </div>
            <span class="cv-shipping">Sped. €{{getSpedizione(esclusiva).toFixed(2)}}</span>
          </div>

          <div class="ci2" *ngFor="let item of esclusiva.items">
            <div class="ci-img"><img [src]="item.Immagine" style="max-width: 100%; max-height: 100%; object-fit: cover"></div>
            <div class="ci-inf">
              <div class="ci-brand">{{item?.prodotto?.marcaObject?.label ?? 'UNDEFINED'}}</div>
              <div class="ci-nm">{{ item.prodotto_cart?.voce }}</div>
              <div class="ci-mt">Taglia {{tagliaProdottoCarrello(item)}} · {{(item.prodotto?.categorie?.length ? item.prodotto?.categorie[0]?.categoria : null) ?? 'UNDEFINED'}}</div>
              <div class="ci-rw">
                <div class="ci-price-box">
  <span class="ci-pr">
    €{{
      (
        getMyPriceCart(item)?.isPromo
          ? getMyPriceCart(item)?.prezzoSconto
          : getMyPriceCart(item)?.prezzoIvato
      ) * (item.prodotto_cart?.quantita ?? 1)
        | number: '2.2-2'
    }}
  </span>

                  <span class="ci-old" *ngIf="getMyPriceCart(item)?.isPromo">
    €{{
                      getMyPriceCart(item)?.prezzoIvato * (item.prodotto_cart?.quantita ?? 1)
                        | number: '2.2-2'
                    }}
  </span>

                  <span class="ci-promo-badge" *ngIf="getMyPriceCart(item)?.isPromo">
    -{{getMyPriceCart(item)?.sconto}}%
  </span>
                </div>
                <div class="ci-q">
                  <button class="cqb" *ngIf="item.prodotto_cart?.quantita > 1 && isRichieste()" (click)="updateRow(item, -1)">−</button>
                  <span class="cqn">{{ item.prodotto_cart?.quantita}}</span>
                  <button class="cqb" *ngIf=" isRichieste()" (click)="updateRow(item, 1)">+</button>
                  <button class="crm" *ngIf=" isRichieste()" (click)="deleteRow(item)">Rimuovi</button>
                </div>
              </div>
            </div>
          </div>
          <div class="cv-subtotal"><span>Subtotale</span><span>€{{getEsclusivaSubtotal(esclusiva)??0|number: '2.2-2'}}</span></div></div></div>
      <div id="rcft" style="display: block;" class="cft" *ngIf="Prodotti?.length">
        <div id="rcSummaryRows">
          <div class="cfr"><span>Subtotale prodotti</span><b>€{{getSubtotal()??0|number: '2.2-2'}}</b></div>
          <div class="cfr" *ngFor="let esclusiva of Prodotti"><span>Spedizione {{esclusiva.esclusiva?.nominativo ?? 'UNDEFINED'}}</span><b>€{{getSpedizione(esclusiva)|number: '2.2-2'}}</b></div>
        </div>
        <div class="cfr tot"><span>Totale stimato</span><span id="rctot">€{{getTotale()??0|number: '2.2-2'}}</span></div>
        <button class="ccta prenota" id="rCtaBtn" *ngIf="isRichieste()" [disabled]="disableConf" (click)="confermaRichieste()">
          <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24" style="display:inline;margin-right:6px;vertical-align:middle"><path d="M9 12l2 2 4-4"></path><circle cx="12" cy="12" r="10"></circle></svg>
          Conferma richieste
        </button>
        <button class="ccta ordina" *ngIf="isCarrello()" id="cCtaBtn"  [disabled]="disableConf" (click)="cartPay()">Procedi all'ordine →</button>
        <p class="ccta-note" id="cCtaNote" *ngIf="isCarrello()">Tutti i venditori hanno confermato la disponibilità. Puoi completare l'acquisto.</p>
        <p class="ccta-note" *ngIf="isRichieste()" >Stai richiedendo il prodotto. Se il venditore conferma, l'ordine è vincolante.</p>
      </div>
    </div>

  `,
  styles:[
    `
      .cov{display:none;position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:500;}
      .cov.open{display:block;}
      .cdr{position:fixed;top:0;right:-480px;bottom:0;width:460px;background:#F5F7FA;z-index:501;display:flex;flex-direction:column;box-shadow:var(--s3);transition:right .27s cubic-bezier(.4,0,.2,1);}
      .cdr.open{right:0;}
      /* Header */
      .cdr-h{display:flex;align-items:center;justify-content:space-between;padding:16px 20px;border-bottom:1px solid #E2E8F0;background:#fff;}
      .cdr-h-left{display:flex;flex-direction:column;gap:2px;}
      .cdr-h h2{font-size:17px;font-weight:900;margin:0;}
      .cdr-h-badge{display:inline-flex;align-items:center;background:var(--blue);color:#fff;border-radius:20px;padding:2px 10px;font-size:11px;font-weight:800;width:fit-content;}
      .cx{border:none;background:none;font-size:21px;color:var(--muted);padding:2px 6px;border-radius:4px;cursor:pointer;}
      .cx:hover{background:var(--bg);}
      /* Shipping info banner */
      .c-info-banner{
        display:flex;gap:10px;align-items:flex-start;
        margin:12px 16px;padding:11px 13px;
        background:#FFFBEB;border:1px solid #FDE68A;border-radius:8px;
        font-size:12px;color:#78350F;line-height:1.55;
      }
      .c-info-banner svg{flex-shrink:0;color:#F59E0B;margin-top:1px;}
      /* Cart body */
      .citems{flex:1;overflow-y:auto;padding:0 16px 12px;}
      .ce{text-align:center;padding:52px 0;color:var(--muted);}
      .ce .ci{font-size:44px;margin-bottom:10px;}
      .ce p{font-size:14px;font-weight:700;}
      /* Vendor block */
      .cv-block{background:#fff;border:1px solid #E2E8F0;border-radius:12px;margin-bottom:12px;overflow:hidden;}
      .cv-header{
        display:flex;align-items:center;justify-content:space-between;
        padding:10px 14px;background:var(--blue)!important;
        font-size:12.5px;font-weight:800;color:#fff;
      }
      .cv-header-left{display:flex;align-items:center;gap:7px;}
      .cv-header svg{opacity:.85;}
      .cv-shipping{font-size:11.5px;font-weight:700;opacity:.9;}
      /* Vendor status badge */
      .cv-status{
        display:flex;align-items:center;gap:6px;
        padding:8px 14px;font-size:12px;font-weight:700;border-bottom:1px solid #E2E8F0;
      }
      .cv-status.attesa{background:#FFFBEB;color:#78350F;}
      .cv-status.confermato{background:#CCFBF1;color:#134E4A;}
      .cv-status.rifiutato{background:#FEE2E2;color:#7F1D1D;}
      .cv-status svg{flex-shrink:0;}
      /* Cart items */
      .ci2{display:flex;gap:11px;padding:12px 14px;border-bottom:1px solid #F1F5F9;}
      .ci2:last-child{border-bottom:none;}
      .ci-img{width:58px;height:72px;border-radius:8px;background:linear-gradient(145deg,#E6F4F3,#CCFBF1);display:flex;align-items:center;justify-content:center;font-size:24px;flex-shrink:0;border:1px solid #E2E8F0;}
      .ci-inf{flex:1;min-width:0;}
      .ci-nm{font-size:13px;font-weight:800;margin-bottom:1px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
      .ci-brand{font-size:11px;font-weight:700;color:var(--blue);text-transform:uppercase;letter-spacing:.3px;margin-bottom:2px;}
      .ci-mt{font-size:11.5px;color:var(--muted);margin-bottom:6px;}
      .ci-rw{display:flex;align-items:center;justify-content:space-between;}
      .ci-pr{font-size:14.5px;font-weight:900;color:#0F172A;}
      .ci-q{display:flex;align-items:center;gap:6px;}
      .cqb{width:26px;height:26px;border:1.5px solid #E2E8F0;border-radius:50%;background:#fff;font-size:15px;font-weight:900;display:flex;align-items:center;justify-content:center;transition:all .12s;cursor:pointer;}
      .cqb:hover{border-color:var(--blue);color:var(--blue);}
      .cqn{font-size:13px;font-weight:900;min-width:20px;text-align:center;}
      .crm{border:none;background:none;color:var(--muted);font-size:11.5px;font-weight:700;padding:2px 5px;cursor:pointer;text-decoration:underline;}
      .crm:hover{color:var(--red);}
      /* Vendor subtotal row */
      .cv-subtotal{display:flex;justify-content:space-between;padding:9px 14px;font-size:12.5px;color:var(--muted);border-top:1px dashed #E2E8F0;}
      .cv-subtotal span:last-child{font-weight:800;color:#0F172A;}
      /* Footer */
      .cft{padding:14px 16px 18px;border-top:1.5px solid #E2E8F0;background:#fff;}
      .cfr{display:flex;justify-content:space-between;font-size:13px;padding:3px 0;color:var(--muted);}
      .cfr b{color:#0F172A;}
      .cfr.tot{font-size:16px;font-weight:900;color:#0F172A;border-top:1.5px solid #E2E8F0;padding-top:10px;margin-top:7px;}
      .cfr.tot span:last-child{color:var(--blue);}
      /* CTAs */
      .ccta{
        width:100%;padding:13px;border:none;border-radius:8px;
        font-size:15px;font-weight:900;margin-top:10px;
        transition:background .12s;cursor:pointer;font-family:var(--font);
      }
      .ccta.prenota{background:var(--blue);color:#fff;}
      .ccta.prenota:hover{background:#2f3dc0;}
      .ccta.ordina{background:#0F172A;color:#fff;}
      .ccta.ordina:hover{background:#2f3dc0;}
      .ccta.disabled{background:#E2E8F0;color:#94A3B8;cursor:not-allowed;}
      .ccta-note{font-size:11.5px;color:var(--muted);text-align:center;margin-top:7px;line-height:1.5;}
      /* Partial checkout banner */
      .c-partial-banner{background:#CCFBF1;border:1px solid #99F6E4;border-radius:8px;padding:10px 13px;margin-bottom:10px;font-size:12px;color:#134E4A;font-weight:700;}

    `
  ]
})
export class CarrelloMarketplaceComponent implements OnInit {
  cartData: any = {data:[], richieste:0, open:false};
  Prodotti;
  disableConf = false;
  CostoSpedizioneFisso = 0;
  percSpedizione = 0;
  constructor(
    private store: GlobalStoreService,
    private api: ApiPathsService,
    private auth: AuthenticationService,
    private toastr: ToastrService
  ) {
  }
  closeRichieste(){
    if(this.isRichieste())
      this.store.toggleCart();
    if(this.isCarrello())
      this.store.togglecarrelloCart();
  }
  ngOnInit() {
    this.store.$cartData.subscribe(data => {
      this.cartData = data;
      if(data?.open == true) {
        this.serializeProdotti(data?.data ?? [])
      }
      if(data?.openCarrello){
        if(data.dataCarrello.length > 0)
        this.api.ClassicPost("/progetti/progetti/check", {ids: data.dataCarrello.map(x => x.id)}).subscribe(res=>{
          data.dataCarrello.forEach((x,i) => {
            if(!res.includes(x.id)){
              data.dataCarrello.splice(i, 1);
              var carrello = GetCarrello()
              var index = carrello.findIndex(y => x.id == y.id);
              carrello.splice(index, 1);
              SaveToLocalStorage('carrello', carrello);
              this.store.getCartData();
            }

          })


          var allprod = GetCarrelloVoci(data.dataCarrello);
          this.serializeProdotti(allprod);
        })

      }
    })

    this.api.ClassicGet("/progetti/costi/spedizione").subscribe((res:{id:number, check:string, codice:string}[]) => {
      console.log("spedizione get", res);
      var costoFisso = res.filter(x=>x.id==5).reduce((a, b) => a + parseFloat(b.codice), 0);
      console.log("costo Fisso Spedizione: ", costoFisso);
      var perc = res.filter(x=>x.id==6).reduce((a, b) => a + parseFloat(b.codice), 0);
      console.log("% Maggiorazione Spedizione", perc);
      this.CostoSpedizioneFisso = costoFisso;
      this.percSpedizione = perc;
    })

  }
  isCarrello(){
    return this.cartData?.openCarrello;
  }
  isRichieste(){
    return this.cartData?.open;
  }
  Count(){
    return this.isCarrello() ? GetCarrelloCount(this.store) :this.cartData?.richieste
  }

  tagliaProdottoCarrello(item){
    return item.prodotto?.taglie?.find(t => t.id === item.prodotto_cart?.taglia)?.label  ?? ''
  }

  getMyPriceCart(item: any) {
    return GetMyPrice(item.prodotto, this.auth.currentUserValue);
  }

  serializeProdotti(data){
    this.Prodotti = [];
    var prodotti = data?.map(x => this.api.ClassicPost("/prodotti/get", {id: x.prodotto_id}).pipe(map((data) => {
      return {prodotto_cart: x, prodotto: data};
    })))
    forkJoin(prodotti ?? []).subscribe(async (res:any[]) => {
      const map = new Map<string, any>();
      for (const item of res) {
        var imgs = await idsToBase64([item.prodotto.id_immagine], this.api.getBaseAPI())
        const key = `${item.prodotto?.esclusiva}`;
        item.Immagine = imgs[0];
        if (!map.has(key)) {
          map.set(key, {
            esclusiva: item.prodotto.esclusivaObject,
            items:[]
          });
        }
        map.get(key).items.push(item);
      }
      this.Prodotti = [...Array.from(map.values())];
      console.log("Esclusive: ", this.Prodotti)
    })
  }

  getSubtotal(){
    return this.Prodotti?.reduce((acc, esclusiva) => acc + getEsclusivaSubtotal(esclusiva), 0);
  }

  getSpedizione(esclusiva: {esclusiva:{id: number, nominativo: string}, items: {prodotto_cart: any, prodotto: any}[]}){
    return getSpedizione(esclusiva,this.percSpedizione, this.CostoSpedizioneFisso)
  }
  getSpedizioneTotale(){
    return this.Prodotti?.reduce((acc, esclusiva) => acc + this.getSpedizione(esclusiva), 0);
  }
  getTotale(){
    return this.getSubtotal() + this.getSpedizioneTotale();
  }

  updateRow(item, toAdd: number){
    item.prodotto_cart.quantita = item.prodotto_cart.quantita + toAdd
    this.api.ClassicPost("/progetti/carrello/update", {...item.prodotto_cart, }).subscribe(res => {
      this.store.getCartData();
    })
  }
  deleteRow(item){
    this.api.ClassicPost("/progetti/carrello/delete", {id: item.prodotto_cart.id}).subscribe(res => {
      this.cartData.data.splice(this.cartData.data.indexOf(item), 1);
      this.store.getCartData();
    })
  }
  confermaRichieste(esclusiva?){
    this.disableConf = true;
    if(esclusiva)
      this.addOrdine(esclusiva).subscribe(res => this.onOrderResponse(res, esclusiva), ()=> this.disableConf = false);
    else{
      var requests = this.Prodotti.map(x => this.addOrdine(x));
      forkJoin(requests).subscribe(res => this.onOrderResponse(res, null),()=> this.disableConf = false);
    }
  }
  onOrderResponse(res, esclusiva?){
    if(esclusiva)
      esclusiva.items=[];
    else {
      this.Prodotti = [];
      this.store.toggleCart();
    }
    this.toastr.success("attendi la conferma dal venditore","Richiesta effettuata con successo!", { timeOut:10000, extendedTimeOut:3000, toastClass: 'marketplace-success-toast' });
    this.store.getCartData()
    this.disableConf = false
  }
  addOrdine(esclusiva){
    return this.api.ClassicPost('/progetti/ordini/add',{
      cliente: this.auth.currentUserValue.cliente ?? this.auth.currentUserValue.id,
      note: '',
      /*valOfferta: getEsclusivaSubtotal(esclusiva) + this.getSpedizione(esclusiva),*/
      valOfferta: getEsclusivaSubtotal(esclusiva),
      codice: 'TODO...',
      oggetto: esclusiva?.esclusiva?.nominativo,
      progetti: [{
        voci: esclusiva.items.map(x => {
          const myPrice = GetMyPrice(x.prodotto, this.auth.currentUserValue);
          console.log("prodotto", x.prodotto);
          console.log("prodotto_cart", x.prodotto_cart);
          console.log("myPrice", myPrice);
          console.log("sconto", myPrice?.sconto);
          return {...x.prodotto_cart, quantitaRic:x.prodotto_cart?.quantita, prezzo: myPrice.prezzo, sconto: myPrice?.isPromo ? myPrice.sconto : ''};
        })
      }]
    })
  }

  cartPay(){

  }

  protected readonly GetCarrelloCount = GetCarrelloCount;
  protected readonly PrezzoIvato = PrezzoIvato;
  protected readonly getEsclusivaSubtotal = getEsclusivaSubtotal;
}
